module.exports = __webpack_public_path__ + "img/keder_hellgrau_farbnummer705.37945a66.jpg";